import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import "../../../assets/css/accountmetrics.scss";
import Loader from "../../../reusableComponents/Loader";
import "./ShareCertificates.scss";
import axios from "axios";
import PayoutCertificates from "../PayoutCertificates";
import LifetimeCertificates from "../Lifetime";
import Stage1Certificate from "../Stage1Certificate/Stage1Certificate";
import Stage2Certificate from "../Stage2Certificate/Stage2Certificate";
import FundedCertificate from "../FundedCertificate/FundedCertificate";
import { baseUrl } from "../../../Axios";
import CombinedPopup from "../../../components/Popups/CombinedPopup";
const PublicShareCertificates = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [certificate, setCertificate] = useState();
  const [popUpType, setPopUpType] = useState(""); // Type of popup (e.g., "error", "success")
  const [showPopup, setShowPopup] = useState(false); // Visibility of the popup
  const [combinedPUHead, setCombinedPUHead] = useState(""); // Main heading for the popup
  const [combinedPUBody, setCombinedPUBody] = useState(""); // Subheading or message for the popup
  const { certificateId } = useParams();
  const fetchCertificates = async () => {
    try {
      setIsLoading(true); // Set loading state to true at the start
      const response = await axios.get(
        `${baseUrl}/certificate/${certificateId}/`
      );
      setCertificate(response.data);
      console.log(response, "responseresponse");
    } catch (error) {
      console.error("Error fetching certificates:", error);
  
      // Prepare modal content for errors
      let errorMessage = "An error occurred while fetching certificates.";
      if (error.response) {
        if (error.response.status === 403) {
          errorMessage = "Access denied: You do not have permission to view this certificate.";
        } else {
          errorMessage = error.response.data?.error || `Error: ${error.response.status} - ${error.response.statusText}`;
        }
      } else if (error.request) {
        errorMessage = "No response received from the server. Please try again.";
      } else {
        errorMessage = `Request error: ${error.message}`;
      }
  
      // Set modal state
      setPopUpType("error");
      setShowPopup(true);
      setCombinedPUHead("Oh snap!");
      setCombinedPUBody(errorMessage);
    } finally {
      setIsLoading(false); // Ensure loading state is updated regardless of success or failure
    }
  };
  
  useEffect(() => {
    fetchCertificates();
  }, [certificateId]);
  

  const renderCertificateComponent = (item) => {
    switch (item?.type) {
      case "Profit Split":
        return (
          <PayoutCertificates
            publicShareTrue={true}
            key={item.id}
            data={item}
          />
        );
      case "Lifetime Payout":
        return (
          <LifetimeCertificates
            publicShareTrue={true}
            key={item.id}
            data={item}
          />
        );
      case "Stage 1 Pass":
        return (
          <Stage1Certificate publicShareTrue={true} key={item.id} data={item} />
        );
      case "Stage 2 Pass":
        return (
          <Stage2Certificate publicShareTrue={true} key={item.id} data={item} />
        );
      case "Funded Profit":
        return (
          <FundedCertificate publicShareTrue={true} key={item.id} data={item} />
        );
      default:
        return null;
    }
  };

  return (
    <div
      className="AccountMetricsContainer publicSharePage publicShareCertificates"
      style={{ position: "relative" }}
    >
       <CombinedPopup
          type={popUpType}
          trigger={showPopup}
          setTrigger={setShowPopup}
          head={combinedPUHead}
          subhead={combinedPUBody}
          onClick={()=>navigate("https://app.alphacapitalgroup.uk/")}
        />
      {isLoading && <Loader open={isLoading} />}

      <div className="topHeaderBox">
        <h1>
          Alpha<span> Capital</span>
        </h1>
        <div className="rightCornerSect exclude">
          <button onClick={() => navigate("/signup")}>Sign Up</button>
        </div>
      </div>

      <div className="share-certificates">
        {certificate && renderCertificateComponent(certificate)}
      </div>
    </div>
  );
};

export default PublicShareCertificates;
